import { AlyviaUser } from "common/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AlyviaUserStore = {
  alyviaUser: AlyviaUser | null;
  setUser: (alyviaUser: AlyviaUser) => void;
  resetUser(): void;
};

export const useAlyviaUserStore = create<AlyviaUserStore>()(
  persist(
    (set): AlyviaUserStore => ({
      alyviaUser: null,
      setUser: (alyviaUser: AlyviaUser) => set({ alyviaUser }),
      resetUser: () => set({ alyviaUser: null }),
    }),
    {
      name: "alyviaUser-store",
    },
  ),
);

// export const useAlyviaUserStore = create<AlyviaUserStore>(
//   (set): AlyviaUserStore => ({
//     alyviaUser: null,
//     setUser: (alyviaUser: AlyviaUser) => set({ alyviaUser }),
//     resetUser: () => set({ alyviaUser: null }),
//   })
// );
